import { PYTHON_API_BASE_URL } from "../../../services/api/apiConstants";
import { encryptPassword } from "../../../encryption";

function buildHeaders({ accessToken, userId }) {
  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    "X-User-ID": userId || "",
  };
}

export async function fetchCustomersByBranch({ accessToken, branchId, userId }) {
  const endpoint = `${PYTHON_API_BASE_URL}/customers/by-branch/?branch_id=${branchId}`;

  const response = await fetch(endpoint, {
    method: "GET",
    headers: buildHeaders({ accessToken, userId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch customers: ${response.status}`);
  }

  const data = await response.json();
  return data.customers || [];
}

export async function updateCustomer({ accessToken, userId, customerId, formData }) {
  const response = await fetch(`${PYTHON_API_BASE_URL}/users/update/`, {
    method: "PUT",
    headers: buildHeaders({ accessToken, userId }),
    body: JSON.stringify({
      user_id: customerId,
      first_name: formData.firstName,
      last_name: formData.lastName,
      phone: formData.phone,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    const errorMsg = data.error?.message || data.error || "Failed to update customer. Please try again.";
    throw new Error(errorMsg);
  }

  return data;
}

export async function createCustomer({ accessToken, userId, branchId, formData }) {
  const response = await fetch(`${PYTHON_API_BASE_URL}/customers/create/`, {
    method: "POST",
    headers: buildHeaders({ accessToken, userId }),
    body: JSON.stringify({
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      password: encryptPassword(formData.password),
      phone: formData.phone,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      zip_code: formData.zipCode,
      address_line: formData.addressLine,
      utility_company_name: formData.utilityCompanyName,
      utility_account_number: formData.utilityAccountNumber,
      employee: userId,
      branch_id: branchId,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    let errorMsg = "Failed to create customer. Please try again.";
    if (typeof data.error === "string") {
      const parts = data.error.split(":");
      errorMsg = parts[parts.length - 1].trim();
    } else if (data.error?.message) {
      errorMsg = data.error.message;
    }
    throw new Error(errorMsg);
  }

  return data;
}
